import React from 'react';
import { Switch, Tooltip } from 'antd';
import { TransactionTableFiltersProps } from '../types/transaction.types';

export const TransactionTableFilters: React.FC<
  TransactionTableFiltersProps
> = ({
  isAdjustedReturn,
  showAdjustedTransactions,
  onAdjustedTransactionsChange,
  t,
}) => {
  if (!isAdjustedReturn) return null;

  const label = t('vat-checker.show-adjusted');

  return (
    <div className="scope-vat-show-adjusted-filter">
      <span className="scope-vat-show-adjusted-filter__label">{label}</span>
      <Tooltip
        title={
          showAdjustedTransactions
            ? t('common.toggle-on-click-to-turn-off')
            : t('common.toggle-off-click-to-turn-on')
        }
      >
        <Switch
          size="small"
          className={showAdjustedTransactions ? 'switch-checked' : ''}
          checked={showAdjustedTransactions}
          aria-label={label}
          onChange={(checked: boolean) => onAdjustedTransactionsChange(checked)}
        />
      </Tooltip>
    </div>
  );
};
